<template>
  <stats-collection icon="&#xE1B3;" :items="items" />
</template>

<script>
import { map, filter, get } from 'lodash'
import { arrToStr } from 'utils/string'
import { getEventKeypath } from 'config/settings'
import StatsCollection from 'views/elements/stats/StatsCollection'

export default {
  components: {
    StatsCollection,
  },

  computed: {

    items () {
      const items = []
      if (this.currentEvent) {
        items.push({label: this.$t('audience.user_timeline.current.event'), value: this.currentEvent})
      }
      if (this.currentMoment) {
        items.push({label: this.$t('audience.user_timeline.current.moment'), value: this.currentMoment})
      }
      return items
    },

    events() {
      return this.$store.state.user.event_history
    },

    moments() {
      return this.$store.state.user.moment_history
    },

    currentEvent() {
      let current = filter(this.events, item => item.end_ts === null)
      
      current = map(current, item => {
        const id = item.type === 'Stationary' ? get(item, 'location.significance') : item.mode
        const keypath = getEventKeypath(id)

        if (keypath) {
          return this.$t(keypath)
        }

        return id
      })

      current = filter(current)

      return arrToStr(current)
    },

    currentMoment() {
      let current = filter(this.moments, item => item.end_ts === null && item.type === 'GenericMoment')

      current = map(current, item => item.moment_definition.display_name)
      current = filter(current)

      return arrToStr(current)
    }
  }
}
</script>
